import {
  EDIT_BAZAAR_REQUEST,
  EDIT_BAZAAR_SUCCESS,
  EDIT_BAZAAR_FAILURE,
  EDIT_BAZAAR_RESET,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const editBazaarReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_BAZAAR_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case EDIT_BAZAAR_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Bazaar updated successfully",
      }

    case EDIT_BAZAAR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case EDIT_BAZAAR_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default editBazaarReducer
